import { createContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatParams } from 'shared/utils';
import { CARDS_TOTALS_PATH } from '../routes';

interface ICardTotalsSearchContext {
  searchCardNumber(data: { tarjeta: string; selectdate: string }): void;
  cardNumber: string;
}

export const CardTotalsSearchContext = createContext<ICardTotalsSearchContext>({
  searchCardNumber: () => {},
  cardNumber: null,
});

export const CardTotalsSearchProvider = ({ children }) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const [cardNumber, setCardNumber] = useState(state && state['tarjeta']);

  const contextValue = {
    searchCardNumber: (data: { tarjeta: string; selectdate: string }) => {
      setCardNumber(data.tarjeta);
      navigate(
        {
          pathname: CARDS_TOTALS_PATH.replace(
            ':cardNumber',
            data.tarjeta.replace(/\d(?=\d{4})/g, 'X'),
          ),
          search: formatParams(data.selectdate),
        },
        {
          state: {
            tarjeta: data.tarjeta,
          },
        },
      );
    },
    cardNumber,
  };
  return (
    <CardTotalsSearchContext.Provider value={contextValue}>
      {children}
    </CardTotalsSearchContext.Provider>
  );
};
